import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import Area from 'bundles/apex/deals/show/overview/values/area';
import Card from 'bundles/apex/card/details';
import CustomFields from 'bundles/apex/deals/show/overview/values/custom_fields';
import Percent from 'bundles/apex/deals/show/overview/values/percent';
import PropertyType from 'bundles/apex/deals/show/overview/values/property_type';
import Text from 'bundles/apex/deals/show/overview/values/text';
import TextArea from 'bundles/apex/deals/show/overview/values/textarea';
import { getPropertySectionLabel } from 'bundles/apex/deals/helpers/labels';
import { getLocationLabel } from 'bundles/apex/deals/helpers/labels';
import { getLocation } from 'bundles/apex/deals/helpers';

export function PropertyCard({ deal, fields }) {
  return (
    <Card label={getPropertySectionLabel(deal)}>
      <PropertyType/>
      <Text name="propertyName" />
      <Text name="address" />
      <Text name="address2" />
      <Text label={getLocationLabel(deal, fields)} name="city" value={getLocation(deal)} />
      <Text name="county" />
      <Area name="buildingSize" />
      <Area name="lotSize" />
      <Area name="spaceSize" />
      <Percent name="occupancyPercent" />
      <Text name="yearBuilt" />
      <Area name="numberOfUnits" />
      <TextArea name="requirements" />
      <CustomFields category="property" />
    </Card>
  );
}

PropertyCard.propTypes = {
  deal: PropTypes.shape({
    dealType: PropTypes.string.isRequired,
  }).isRequired,
  fields: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
  fields: state.fields,
});

export default connect(mapStateToProps)(PropertyCard);
